export const generateCodigo = (nombre = '', apellido = '') => {
  // Si no se proporcionan nombre y apellido, se genera un código numérico de 6 dígitos.
  if (!nombre.trim() && !apellido.trim()) {
    const numericCode = Math.floor(Math.random() * 900000 + 100000).toString();
    return numericCode;
  }

  // Si se proporciona alguno de ellos, se usan sus primeras letras en mayúsculas.
  const primeraLetraNombre = nombre.trim().length > 0
    ? nombre.trim()[0].toUpperCase()
    : 'X';

  const apellidos = apellido.trim().split(' ');
  const primerApellido = apellidos.length > 0 ? apellidos[0] : '';
  const primeraLetraApellido = primerApellido.length > 0
    ? primerApellido[0].toUpperCase()
    : 'Y';

  const random = Math.random().toString(36).substr(2, 6).toUpperCase();

  return `${primeraLetraNombre}${primeraLetraApellido}-${random}`;
};
